import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { StartComponent } from './start/start.component';
import { PersonalInformationComponent } from './personal-information/personal-information.component';
import { QuestionsComponent } from './questions/questions.component';
import { SummaryComponent } from './summary/summary.component';
import { PollComponent } from './poll/poll.component';


// const routes: Routes = [
//   {path: 'poll', component: PollComponent},
//   {path: 'start', component: StartComponent},
//   {path: 'personalInformation', component: PersonalInformationComponent},
//   {path: 'questions', component: QuestionsComponent},
//   {path: 'summary', component: SummaryComponent},
//   {path: '', redirectTo: 'start', pathMatch: 'full'}
// ];

@NgModule({
  imports: [],
  exports: [RouterModule]
})
export class AppRoutingModule { }
